import "../version.js";

import { Container } from "inversify";
import "reflect-metadata";

import IBootConfig from "../framework/src/boot/IBootConfig";
import { boot } from "../framework/src/boot/boot";
import SERVICE_IDENTIFIER from "../framework/src/constants/identifiers";
import IframeInfopages from "../framework/src/engine/IframeInfoPages";
import { defineEngine } from "../framework/src/engine/pixi/bootPixiEngine";
import { defineSlotGame as defineGame } from "../framework/src/game/defineGame";
import initSettings from "../framework/src/settings/initSettings";
import { defineSystem } from "../framework/src/system/defineSystem";
import { defineUI } from "../framework/src/ui/defineUI";
import Commander from "./Commander";
import { defineJokerWinBanner } from "./JokerWinBanner";
import SymbolFactory from "./Symbols/SymbolFactory";
import { defineGameParts } from "./defineGameparts";

let container = new Container();

container.bind(SERVICE_IDENTIFIER.Commander).to(Commander).inSingletonScope();

const config: IBootConfig = {
	EngineAppSymbols: SymbolFactory,
	InfoPages: IframeInfopages,
};

export async function run(gameset) {
	defineSystem(gameset, container);
	defineEngine(container, config);
	defineGame(container);
	try {
		await initSettings(container);
	} catch (error) {
		return
	}	
	defineUI(container);
	defineGameParts(container);
	defineJokerWinBanner(container);
	boot(container);
}
